/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*----------------------------Pauls Custom Code-----------------------------*/
/*----------------------------Allows annimation on Getting Busy section-----------------------------*/
// var the_position = 1;



// var myInterval = window.setInterval(myAnimation, 10);

// function myAnimation() {
//   console.log("HERE");
//   var the_counter = 1;
//   var the_width = 30;
//   jQuery('.GettingBusy_Container').each(function( index ) {
//     the_counter++;
   
//     if(the_counter % 2 == 0) {
//       jQuery(this).css("margin-top", 11 * Math.sin(the_position/1900)+"%");
//       jQuery(this).css("margin-left", 1 * Math.cos(the_position/2100)+"%");
//     }else if (the_counter % 3 == 0) {
//       jQuery(this).css("margin-top", 9 * Math.cos(the_position/1000)+"%");
//       jQuery(this).css("margin-left", 5 * Math.sin(the_position/2000)+"%");
//     }else if (the_counter % 4 == 0) {
//       jQuery(this).css("margin-top", 8 * Math.cos(the_position/900)+"%");
//       jQuery(this).css("margin-left", 5 * Math.sin(the_position/2900)+"%");
//     }else {
//       jQuery(this).css("margin-top", 10 * Math.sin(the_position/700)+"%");
//       jQuery(this).css("margin-left", 3 * Math.cos(the_position/900)+"%");
//     }
//     jQuery(this).css("width", the_width + "%");
//   	the_position += 2.5;
//     });	
  
// }

// jQuery('.GettingBusy_Container').hover(
//   	function( e ) {
//   		clearInterval(myInterval);
// 	},
//   	function( e ) {
//   		myInterval = window.setInterval(myAnimation, 10);
// 	}
// );


  
  jQuery('.award-carousel').flickity({
  // options
  cellAlign: 'center',
  prevNextButtons: true,  
  draggable: true,
  contain: true,
  wrapAround: true,
  pageDots: false
});


function resize() {
    if (jQuery(window).width() < 780) {
     jQuery('.VideoHero').addClass('ImageHero--large');
      jQuery('.VideoHero').removeClass('ImageHero--preserveRatio');
    }
    else {
      jQuery('.VideoHero').removeClass('ImageHero--large');
      jQuery('.VideoHero').addClass('ImageHero--preserveRatio');
    }
}

jQuery(document).ready( function() {
    jQuery(window).resize(resize);
    resize();
  
  jQuery(function() {

    
    jQuery('p:contains(Kosher)').each(function(index, elem) {
      jQuery(elem).html(function(i,text) {return text.replace(/Kosher/gi, '<span class="kosher-white">Kosher</span>')});
    });
    
    jQuery('.ProductMeta__Feature:contains(Kosher)').each(function(index, elem) {
      jQuery(elem).html(function(i,text) {return text.replace(/Kosher/gi, '<span class="kosher">Kosher</span>')});
    });
    
    jQuery('.collection-feature:contains(Kosher)').each(function(index, elem) {
      jQuery(elem).html(function(i,text) {return text.replace(/Kosher/gi, '<span class="kosher-white">Kosher</span>')});
    });
    
    jQuery('.Faq__Question:contains(Kosher)').each(function(index, elem) {
      jQuery(elem).html(function(i,text) {return text.replace(/Kosher/gi, '<span class="kosher-white">Kosher</span>')});
    });

  });  
  
});


// Fix for the news on the home below 

$(document).ready(function() {
  $('#section-template--14841721946202__1646781652f7e8b2fd > div > div > div.ImageHero__ContentOverlay.the-margalicious-margarita > div > div.FeatureText__ContentWrapper > header > a').attr('href', 'https://www.thomasashbourne.com/products/thomas-ashbourne-margalicious-margarita-375ml-bottle');
});
$(document).ready(function() {
  $('#section-template--14841721946202__prod_2 > div > div > div.ImageHero__ContentOverlay.the-perfect-cosmo-by-sjp > div > div.FeatureText__ContentWrapper > header > a').attr('href', 'https://www.thomasashbourne.com/products/thomas-ashbourne-perfect-cosmo-375ml-bottle');
});
$(document).ready(function() {
  $('#section-template--14841721946202__prod_3 > div > div > div.ImageHero__ContentOverlay.the-old-fashioned > div > div.FeatureText__ContentWrapper > header > a').attr('href', 'https://www.thomasashbourne.com/products/thomas-ashbourne-classic-old-fashioned-375ml-bottle');
});
$(document).ready(function() {
  $('#section-template--14841721946202__prod_4 > div > div > div.ImageHero__ContentOverlay.the-hardscatto > div > div.FeatureText__ContentWrapper > header > a').attr('href', 'https://www.thomasashbourne.com/products/thomas-ashbourne-hardscatto-375ml-bottle');
});


  document.querySelector('#byobApp > div > div > div.byob-gpo-wrapper > div > label').innerHTML = "Option: " 
